import icons from 'url:../../img/icons.svg';
import View from './View.js';

class PaginationView extends View {
  // _parentEl;
  // _data;

  addHandlerClick(handler) {
    this._parentEl.addEventListener('click', e => {
      if (e.target.closest('.pagination__btn--prev'))
        handler(this._data.page - 1);

      if (e.target.closest('.pagination__btn--next'))
        handler(this._data.page + 1);
    });
  }

  _generateMarkup() {
    const curPage = this._data.page;
    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );

    if (curPage === 1 && numPages > 1) return this._generateMarkupNext();

    if (curPage === numPages && numPages > 1)
      return this._generateMarkupPrevious();

    if (curPage < numPages)
      return this._generateMarkupPrevious() + this._generateMarkupNext();

    return '';
  }
  _generateMarkupPrevious(page = this._data.page) {
    return `
      <button class="btn--inline pagination__btn--prev">
        <svg class="search__icon">
          <use href="${icons}#icon-arrow-left"></use>
        </svg>
        <span>Page ${page - 1}</span>
      </button>`;
  }
  _generateMarkupNext(page = this._data.page) {
    return `
      <button class="btn--inline pagination__btn--next">
        <span>Page ${page + 1}</span>
        <svg class="search__icon">
          <use href="${icons}#icon-arrow-right"></use>
        </svg>
      </button>`;
  }
}

export default new PaginationView('.pagination');
